const Row = ({ items, sep }) => (
  <div className="og-marquee-row" aria-hidden>
    {items.map((t, i) => (
      <span key={i} className="flex items-center">
        <span>{t}</span>
        <span className="og-sep">{sep}</span>
      </span>
    ))}
  </div>
);

export const Marquee = ({ items, variant = "red", speed = 30, reverse = false, sep = "✦", className = "", testid }) => {
  const list = [...items, ...items, ...items];
  return (
    <div
      data-testid={testid}
      className={`og-marquee og-marquee--${variant} ${className}`}
      style={{ "--dur": `${speed}s`, "--dir": reverse ? "reverse" : "normal" }}
    >
      <span className="sr-only">{items.join(" — ")}</span>
      <div className="og-marquee-track">
        <Row items={list} sep={sep} />
        <Row items={list} sep={sep} />
      </div>
    </div>
  );
};

export const CrossBands = ({ a, b }) => (
  <div data-testid="cross-bands" className="relative h-[220px] md:h-[300px] overflow-hidden bg-[#050505]">
    <div className="absolute inset-x-[-10%] top-1/2 -translate-y-1/2 rotate-[-4deg]">
      <Marquee items={a} variant="red" speed={26} />
    </div>
    <div className="absolute inset-x-[-10%] top-1/2 -translate-y-1/2 rotate-[3deg]">
      <Marquee items={b} variant="white" speed={34} reverse />
    </div>
  </div>
);
